import React, { useState, Fragment, useMemo } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import InputAdornment from '@material-ui/core/InputAdornment';

import {
    PatientHistoryCard,
    Text,
    NoInformation,
    GoBackButton,
    MonthSelector,
    SearchIcon,
    InputWithEndAdornment,
    ContainedButton,
    HomeworkProgress,
} from '../../index';

import PatientPresentRecord from './PatientPresentRecord';

import { mindgymReport, mindgymDownloadReport } from '../../../services/index';

import { alertError } from '../../../redux/stateActions';

import { ACTIVITIES } from '../../../constant/index';

import { getMindGymAPIUrl } from '../../../utils/urlFactory';

import { processMindgymReport } from '../../../utils/mindgym';

const AppointmentHistory = ({
    data,
    selectedMonth,
    selectedYear,
    setSelectedMonth,
    setSelectedYear,
    searchValue,
    setSearchValue,
}) => {
    const dispatch = useDispatch();

    const [selectedRecord, setSelectedRecord] = useState({});
    const [reportUrl, setReportUrl] = useState(null);
    const [loading, setLoading] = useState(false);

    const handleDetail = (record) => {
        const { patient_summaries } = record;

        if (!_.isEmpty(patient_summaries)) {
            const patientSummary = patient_summaries[0];

            setSelectedRecord(patientSummary);

            console.log('patientSummary', patientSummary);

            if (
                patientSummary?.patient?.user?.uuid &&
                patientSummary?.session?.meet?.type === 'one'
            ) {
                const staffId = patientSummary?.session?.meet?.staff?.id;
                const sessionId = patientSummary?.session?.id;
                handleGetMindGymReport(staffId, sessionId);
                setReportUrl({
                    staffId: staffId,
                    sessionId: sessionId,
                });
            }
        }
    };

    const onGoback = () => {
        setSelectedRecord({});
        setMindgymActivity({});
    };

    /*--------------- Mindgym Activity ---------------*/
    const [mindgymActivity, setMindgymActivity] = useState([]);

    const handleGetMindGymReport = async (staffId, sessionId) => {
        try {
            if (!staffId || !sessionId) return;

            const res = await mindgymReport(staffId, sessionId);

            if (res?.data?.statusCode === 200) {
                setMindgymActivity(processMindgymReport(res?.data?.data));
            }
        } catch (error) {
            console.log('error', error.response);
            dispatch(
                alertError(`Cannot get Friday Activity: ${error.response?.data?.message}`)
            );
        }
    };

    const handleReportMindgym = async () => {
        try {
            setLoading(true);

            const res = await mindgymDownloadReport(reportUrl.staffId, reportUrl.sessionId);

            console.log('res', res);

            const file = new Blob([res.data], { type: 'application/pdf' });
            file.name = 'test.pdf';
            console.log('file', file);
            const fileURL = URL.createObjectURL(file);
            console.log('fileURL', fileURL);
            window.open(fileURL);

            // const url = window.URL.createObjectURL(new Blob([res.data]));
            // const link = document.createElement('a');
            // link.href = url;
            // link.setAttribute(
            //     'download',
            //     `report_${selectedRecord?.patient?.user?.fullname}_${reportUrl.sessionId}.pdf`
            // );
            // document.body.appendChild(link);
            // link.click();

            setLoading(false);
        } catch (error) {
            console.log('error', error.response);
            dispatch(alertError(`Cannot Display Friday Report: ${error.response?.data?.message}`));
            setLoading(false);
        }
    };

    return (
        <div style={{ display: 'flex', flexDirection: 'column', rowGap: '15px' }}>
            {!_.isEmpty(selectedRecord) ? (
                <div style={{ display: 'flex', flexDirection: 'column', rowGap: '10px' }}>
                    <GoBackButton $text onClick={onGoback} />
                    <PatientPresentRecord data={selectedRecord} />
                </div>
            ) : (
                <Fragment>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                        }}
                    >
                        <Text $fontSize="18px" $medium>
                            Sessions History
                        </Text>
                        <MonthSelector
                            selectedMonth={selectedMonth}
                            selectedYear={selectedYear}
                            setSelectedMonth={setSelectedMonth}
                            setSelectedYear={setSelectedYear}
                        />
                    </div>
                    <InputWithEndAdornment
                        id="search"
                        name="search"
                        placeholder="Search"
                        startAdornment={
                            <InputAdornment
                                position="start"
                                style={{ opacity: 0.6, marginLeft: '10px' }}
                            >
                                <SearchIcon fill="gray2" />
                            </InputAdornment>
                        }
                        type="text"
                        style={{ height: '32px' }}
                        inputPropsStyle={{ paddingLeft: '15px' }}
                        onChange={(e) => setSearchValue(e.target.value)}
                        value={searchValue}
                        autoComplete="off"
                        inputProps={{ maxLength: 100 }}
                    />
                    <div style={{ display: 'flex', flexDirection: 'column', rowGap: '5px' }}>
                        {!_.isEmpty(data) ? (
                            data.map((item) => (
                                <PatientHistoryCard
                                    key={`history${item.id}`}
                                    data={item}
                                    onClick={() => handleDetail(item)}
                                    showTime
                                />
                            ))
                        ) : (
                            <NoInformation />
                        )}
                    </div>
                </Fragment>
            )}
            {!_.isEmpty(mindgymActivity) && (
                <div
                    style={{
                        paddingTop: '15px',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-end',
                    }}
                >
                    <HomeworkProgress data={mindgymActivity} />
                    {/* <a
                        href={`${getMindGymAPIUrl()}/api/report/file/${reportUrl.staffId}/${
                            reportUrl.sessionId
                        }`}
                        style={{ alignSelf: 'end' }}
                    > */}
                    <ContainedButton
                        style={{
                            borderRadius: '8px',
                            width: '240px',
                            height: '38px',
                            marginTop: '20px',
                            marginBottom: '20px',
                            alignSelf: 'end',
                        }}
                        onClick={handleReportMindgym}
                        loading={loading}
                    >
                        <Text $color="white" $fontSize="14px">
                            View Report
                        </Text>
                    </ContainedButton>
                    {/* </a> */}
                </div>
            )}
        </div>
    );
};

AppointmentHistory.propTypes = {
    data: PropTypes.array.isRequired,
    selectedMonth: PropTypes.number.isRequired,
    selectedYear: PropTypes.number.isRequired,
    setSelectedMonth: PropTypes.func.isRequired,
    setSelectedYear: PropTypes.func.isRequired,
    searchValue: PropTypes.string.isRequired,
    setSearchValue: PropTypes.func.isRequired,
};

export default AppointmentHistory;
